import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IThunkAPI } from '@/store/types';
import {
  IInterviewQuestionList,
  IInterviewQuestionPayload,
  IInterviewQuestionSavePayload,
  IInterviewQuestionState,
  IQuestionCategoryList,
} from '../types/types';
import { interviewQuestionApi } from '@/api/admin/interview-question';

const initialState: IInterviewQuestionState = {
  interviewQuestionsList: [],
  allInterviewQuestions: [],
  questionCategories: [],
  interviewQuestionUpdated: false,
};

export const getAllInterviewQuestionsList = createAsyncThunk<Array<IInterviewQuestionList>, number, IThunkAPI>(
  'get/interviewQuestion/list/all',
  async (gigId, thunkAPI) => {
    try {
      const response = await interviewQuestionApi.getAllInterviewQuestionsList(gigId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getQuestionCategoriesList = createAsyncThunk<Array<IQuestionCategoryList>, undefined, IThunkAPI>(
  'get/interviewQuestion/category/list',
  async (_, thunkAPI) => {
    try {
      const response = await interviewQuestionApi.getQuestionCategoriesList();
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
export const getInterviewQuestionsList = createAsyncThunk<Array<IInterviewQuestionList>, number, IThunkAPI>(
  'get/interviewQuestion/list',
  async (gigId, thunkAPI) => {
    try {
      const response = await interviewQuestionApi.getInterviewQuestionsList(gigId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const arrangeQuestionOrder = createAsyncThunk<unknown, IInterviewQuestionPayload, IThunkAPI>(
  'get/interviewQuestion/arrange',
  async (payload, thunkAPI) => {
    try {
      const response = await interviewQuestionApi.arrangeQuestionOrder(payload);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const saveInterviewQuestion = createAsyncThunk<unknown, IInterviewQuestionSavePayload, IThunkAPI>(
  'interviewQuestion/save',
  async (payload, thunkAPI) => {
    try {
      const response = await interviewQuestionApi.saveInterviewQuestion(payload);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const interviewQuestionSlice = createSlice({
  name: 'interviewQuestion',
  initialState,
  reducers: {
    updateAllInterviewQuestions(state, action: PayloadAction<IInterviewQuestionList[]>) {
      state.allInterviewQuestions = action.payload;
    },
    updateInterviewQuestions(state, action: PayloadAction<IInterviewQuestionList[]>) {
      state.interviewQuestionsList = action.payload;
    },
    setInterviewQuestionUpdated(state, action: PayloadAction<boolean>) {
      state.interviewQuestionUpdated = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getInterviewQuestionsList.fulfilled, (state, action) => {
      state.interviewQuestionsList = action.payload;
    });
    builder.addCase(getAllInterviewQuestionsList.fulfilled, (state, action) => {
      state.allInterviewQuestions = action.payload;
    });
    builder.addCase(getQuestionCategoriesList.fulfilled, (state, action) => {
      state.questionCategories = action.payload;
    });
  },
});

export const { updateAllInterviewQuestions, updateInterviewQuestions, setInterviewQuestionUpdated } =
  interviewQuestionSlice.actions;

export default interviewQuestionSlice.reducer;
